import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionsLogin } from '../../actions';
import { ComponentsLoginForm } from "../../components/Login/Form";
import { ServiceLogin } from "../../service/Login";
import { Messages } from 'primereact/messages';
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { ScreensLGPDForm } from '../LGPD/Form';
import { ServiceConfig } from './../../service/Config';

class ScreensLoginConvenioForm extends Component {

    constructor() {

        super();

        this.state = {
            splash: false,
            isLicense: false,
            perfil: "",
            objLGPD: { NomeUsuario: '', Exibir: false, Perfil: "" }
        };

        this.aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';
        this.historicoAceiteLGPD = new HistoricoAceiteLGPD();
        this.serviceLogin = new ServiceLogin();

        // Acesso via QR Code
        var acesso_qrcode = window.location.hash;
        acesso_qrcode = acesso_qrcode.split("=");
        if (acesso_qrcode[1]) {
            var post = { usuario: acesso_qrcode[1].replace("&pass", ""), senha: acesso_qrcode[2] };
            this.handleExecute(post);
        }

        //Acesso via Token
        var acesso_token = window.location.href;
        acesso_token = acesso_token.split("token=");
        if (acesso_token[1]) {
            acesso_token = acesso_token[1].replace("#/", "");
            this.handleExecuteToken(acesso_token);
        }
    }

    componentDidMount() {
        if (sessionStorage.getItem('auth'))
            this.historicoAceiteLGPD.ChecarAceiteLGPD();
    }

    getDadosUsuario(data) {
        return {
            Nome: data.Nome,
            AcessoDTO: {
                UsuarioId: data.Id,
                Perfil: 'Convênio',
                DadosAcesso: ''
            }
        }
    }

    getConfig() {
        try {

            this.serviceConfig = new ServiceConfig();
            this.serviceConfig.GetConfig()
                .then(res => {
                    try {
                        const config = {};
                        let objConfig = {};
                        res.data.map(obj => {
                            config[obj.Key] = { Value: obj.Value };
                        })
                        if (config['NOME_BOTAO_IMPRIMIR_PORTAL'] && config['NOME_BOTAO_IMPRIMIR_PORTAL'].Value) {
                            objConfig.NomeBotaoImprimirPortal = config['NOME_BOTAO_IMPRIMIR_PORTAL'].Value;
                        }
                        
                        if (config['23']) {
                            objConfig['23'] = JSON.parse(config['23'].Value);
                        }
                        sessionStorage.setItem('config', JSON.stringify(objConfig));
                    }
                    catch (error) {
                        console.log(error);
                    }
                })
        } catch(err) {
            console.log("erro catch", err)
        }
    }

    handleExecuteToken(token) {
        this.setState({ splash: true });
        this.serviceLogin.acessoToken(token)
            .then(response => {
                if (this.aceiteLGPD === false)
                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true, Perfil: 'Convênio' } });
                window.location = "#/portal";
            })
            .catch(err => {
                ServiceMessage.warn('Acesso indisponível.');
            })
            .finally(() => { this.setState({ splash: false }); });
    }

    handleExecute(e) {

        if (e.usuario === "")
            return ServiceMessage.warn('Preencha o campo Login.');

        if (e.senha === "")
            return ServiceMessage.warn('Preencha o campo Senha.');

        this.getConfig();

        this.setState({ splash: true });

        this.serviceLogin.loginConvenio(e.usuario, e.senha)
            .then(response => {

                const isLicense = JSON.parse(sessionStorage.getItem("config"));

                if (this.aceiteLGPD === false)
                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true, Perfil: 'Convênio' } });

                if (isLicense['23']) {
                    this.setState({ isLicense: isLicense, perfil: 'convênio' });
                } else {
                    window.location = "#/portal";
                }
            })
            .catch(err => {
                ServiceMessage.warn('Convênio ou senha inválidos!');
            })
            .finally(() => { this.setState({ splash: false }); });
    }

    render() {

        return (
            <div>
                <ScreensLGPDForm objLGPD={this.state.objLGPD} />
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />
                <ComponentsLoginForm
                    onExecute={this.handleExecute.bind(this)} 
                    onResetErroLogin={() => this.setState({ erroLogin: false })}
                    exibirTipo={false}
                    isLicense={this.state.isLicense}
                    perfil={this.state.perfil}
                ></ComponentsLoginForm>
            </div>
        );

    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({ actionsLogin }, dispatch);

const mapStateToProps = store => ({
    login: store.stateLogin.login,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreensLoginConvenioForm);